/* =============================================================================
   Furniselan — Product Dynamic Variant Synchronization
   Handles dynamic update of SKU, Price Ladder, Availability, and Judge.me
   without modifying or conflicting with existing gallery & color swatches.
   ============================================================================= */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.FS && typeof window.FS.formatMoney === 'function') {
      return window.FS.formatMoney(cents);
    }
    var amount = Math.round(cents / 100).toLocaleString('en-IN');
    return '₹' + amount;
  }

  function initVariantSync(context) {
    var scope = context || document.querySelector('.pdp, .product') || document;
    var variantsEl = scope.querySelector('[data-variants]');
    if (!variantsEl) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    // Elements to synchronize
    var skuEl = scope.querySelector('[data-product-sku], #skuLbl');
    var priceEl = scope.querySelector('[data-product-price]');
    var comparePriceEl = scope.querySelector('[data-product-compare-price]');
    var regularPriceEl = scope.querySelector('[data-product-regular-price]');
    var compareRowEl = scope.querySelector('[data-product-compare-row]');
    var regularRowEl = scope.querySelector('[data-product-regular-row]');
    var discountRowEl = scope.querySelector('[data-product-discount-row]');
    var discountBadgeEl = scope.querySelector('[data-product-discount-badge]');
    var discountAmtEl = scope.querySelector('[data-product-discount-amount]');
    var emiEl = scope.querySelector('[data-product-emi]');
    var idInput = scope.querySelector('input[name="id"]');
    var atcBtn = scope.querySelector('#pdpAtc, [data-product-atc]');
    var buyBtn = scope.querySelector('#pdpBuy, [data-buy-now]');
    var buyPriceEl = scope.querySelector('[data-product-buy-price]');

    function updateVariantUI(variant) {
      if (!variant) return;

      // 1. Update SKU dynamically from selected variant
      if (skuEl) {
        skuEl.textContent = variant.sku || '';
        var skuWrapper = skuEl.closest('.sku');
        if (skuWrapper) {
          skuWrapper.style.display = variant.sku ? '' : 'none';
        }
      }

      // 2. Update hidden variant ID for cart
      if (idInput) {
        idInput.value = variant.id;
      }
      scope.querySelectorAll('input[name="id"]').forEach(function(inp) {
        inp.value = variant.id;
      });
      document.querySelectorAll('form[data-product-form] input[name="id"], .product__form input[name="id"]').forEach(function(inp) {
        inp.value = variant.id;
      });

      // 3. Update Prices (Offer price, Compare/MRP, Regular, Discount % and EMI)
      var formattedPrice = formatMoney(variant.price);
      if (priceEl) {
        priceEl.textContent = formattedPrice;
      }
      if (buyPriceEl) {
        buyPriceEl.textContent = formattedPrice;
      }

      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (hasCompare) {
        // Use the same tag-based multiplier as product-form.js & product-card.liquid
        // so that discount % is consistent across Collection Page, Quick View, and PDP.
        //   regularPrice = offerPrice × multiplier
        //   discount%    = (MRP − regularPrice) / MRP × 100
        var tagMult = 1.0;
        var pTags = '';
        var pTagsScript = scope.querySelector('script[data-product-tags]');
        if (pTagsScript) {
          try {
            var parsed = JSON.parse(pTagsScript.textContent);
            pTags = Array.isArray(parsed) ? parsed.join(' ').toLowerCase() : String(parsed || '').toLowerCase();
          } catch (e) {}
        }
        if (!pTags) {
          var pTagsEl = scope.querySelector('[data-product-form][data-product-tags], [data-product-tags]');
          pTags = pTagsEl ? (pTagsEl.dataset.productTags || pTagsEl.getAttribute('data-product-tags') || '').toLowerCase() : '';
        }
        if (pTags.indexOf('20off') > -1) tagMult = 1.25;
        else if (pTags.indexOf('15off') > -1) tagMult = 1.1764;
        else if (pTags.indexOf('10off') > -1) tagMult = 1.111;

        var regP = Math.round(variant.price * tagMult);
        var diff = variant.compare_at_price - regP;
        var pct = Math.round((diff / variant.compare_at_price) * 100);
        var formattedCompare = formatMoney(variant.compare_at_price);

        if (comparePriceEl) {
          comparePriceEl.textContent = formattedCompare;
        }
        if (regularPriceEl) {
          // Regular Price = tag-adjusted price (offer price × multiplier)
          regularPriceEl.textContent = formatMoney(regP);
        }
        if (discountBadgeEl) {
          discountBadgeEl.textContent = pct + '% off';
        }
        if (discountAmtEl) {
          // Extra Discount = difference between regular price and offer price
          var extraDiff = regP - variant.price;
          var extraPct = regP > 0 ? Math.round((extraDiff / regP) * 100) : 0;
          discountAmtEl.textContent = '−' + formatMoney(extraDiff) + ' (' + extraPct + '%)';
        }
        if (compareRowEl) compareRowEl.style.display = '';
        if (regularRowEl) regularRowEl.style.display = '';
        if (discountRowEl) discountRowEl.style.display = '';
      } else {
        if (compareRowEl) compareRowEl.style.display = 'none';
        if (regularRowEl) regularRowEl.style.display = 'none';
        if (discountRowEl) discountRowEl.style.display = 'none';
      }

      // Monthly EMI calculation (over 12 months)
      if (emiEl) {
        var emiVal = Math.round(variant.price / 12);
        emiEl.textContent = formatMoney(emiVal) + '/month';
      }

      // 4. Update ATC and Buy Now availability
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold out';
        if (!variant.available) {
          atcBtn.classList.add('disabled-btn');
          atcBtn.setAttribute('disabled', 'disabled');
        } else {
          atcBtn.classList.remove('disabled-btn');
          atcBtn.removeAttribute('disabled');
        }
      }
      if (buyBtn && !buyBtn.classList.contains('nativeButtonWrapper')) {
        buyBtn.disabled = !variant.available;
        if (!variant.available) {
          buyBtn.classList.add('disabled-btn');
          buyBtn.setAttribute('disabled', 'disabled');
        } else {
          buyBtn.classList.remove('disabled-btn');
          buyBtn.removeAttribute('disabled');
        }
        if (buyPriceEl) {
          if (buyBtn.childNodes && buyBtn.childNodes[0]) {
            buyBtn.childNodes[0].textContent = variant.available ? 'Buy It Now — ' : 'Sold out';
          }
          buyPriceEl.textContent = variant.available ? formattedPrice : '';
        } else {
          buyBtn.textContent = variant.available ? ('Buy It Now — ' + formattedPrice) : 'Sold out';
        }
      }
      var nativeWrapper = scope.querySelector('.nativeButtonWrapper');
      if (nativeWrapper) {
        nativeWrapper.style.display = variant.available ? '' : 'none';
      }

      // 4b. Update product & quick-view title dynamically with selected variant's color
      var pTitle = scope.querySelector('[data-product-title], .product__title');
      if (pTitle) {
        var pColorEl = pTitle.querySelector('[data-title-color]');
        var pBaseEl = pTitle.querySelector('[data-title-base]');
        var pBase = (pBaseEl && pBaseEl.textContent.trim()) || pTitle.getAttribute('data-title-base');
        var vColor = null;
        var pPicker = scope.querySelector('[data-color-picker]');
        var cIdx = pPicker ? parseInt(pPicker.getAttribute('data-option-index'), 10) : -1;
        if (cIdx > -1 && variant.options && variant.options[cIdx]) {
          vColor = variant.options[cIdx];
        } else if (variant.options && variant.options.length) {
          for (var oi = 0; oi < variant.options.length; oi++) {
            if (scope.querySelector('[data-color-swatch][data-color-value="' + variant.options[oi] + '"]')) {
              vColor = variant.options[oi];
              break;
            }
          }
          if (!vColor) vColor = variant.options[0];
        }
        if (vColor) {
          if (pColorEl) pColorEl.textContent = ' - ' + vColor;
          else if (pBase) pTitle.innerHTML = '<span data-title-base>' + pBase + '</span><span data-title-color> - ' + vColor + '</span>';
        }
      }

      var qvTitle = scope.querySelector('.quick-view__title, [data-qv-title-base]');
      if (qvTitle) {
        var qvColorEl = qvTitle.querySelector('[data-qv-color]');
        var qvBaseEl = qvTitle.querySelector('[data-qv-base]');
        var qvBase = (qvBaseEl && qvBaseEl.textContent.trim()) || qvTitle.getAttribute('data-qv-title-base');
        var qvIdx = parseInt(qvTitle.getAttribute('data-qv-color-index'), 10);
        var qvColor = (qvIdx > -1 && variant.options && variant.options[qvIdx]) ? variant.options[qvIdx] : null;
        if (!qvColor && variant.options && variant.options.length) qvColor = variant.options[0];
        if (qvColor) {
          if (qvColorEl) qvColorEl.textContent = ' - ' + qvColor;
          else if (qvBase) qvTitle.innerHTML = '<span data-qv-base>' + qvBase + '</span><span data-qv-color> - ' + qvColor + '</span>';
        }
      }

      // 5. Update browser URL variant query parameter without reload
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }

      // 5b. Refresh Snapmint widget if present
      if (typeof window.loadOnPage === 'function') {
        try { window.loadOnPage(); } catch (e) {}
      }

      // 6. Refresh Judge.me badge if dynamically needed
      if (window.jdgm && typeof window.jdgm.renderBadge === 'function') {
        try {
          window.jdgm.renderBadge();
        } catch (err) {}
      }

      // 7. Update Delivery Image & re-check delivery timeline for this variant
      if (typeof window.updateProductDeliveryImage === 'function') {
        try {
          window.updateProductDeliveryImage(variant.id);
        } catch (err) {}
      }
      if (typeof window.checkProductDelivery === 'function') {
        try {
          var savedPin = localStorage.getItem('fs-pincode');
          if (savedPin && savedPin.length === 6) {
            window.checkProductDelivery(savedPin);
          }
        } catch (err) {}
      }
      window.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    }

    // Function to retrieve the variant matching current state
    function getCurrentVariant() {
      // Priority 1: URL parameter ?variant=
      var urlParams = new URLSearchParams(window.location.search);
      var paramVariantId = urlParams.get('variant');
      if (paramVariantId) {
        var matchedUrl = variants.find(function (v) { return String(v.id) === String(paramVariantId); });
        if (matchedUrl) return matchedUrl;
      }

      // Priority 2: Hidden input id value
      if (idInput && idInput.value) {
        var matchedInput = variants.find(function (v) { return String(v.id) === String(idInput.value); });
        if (matchedInput) return matchedInput;
      }

      // Priority 3: First available variant or first variant
      return variants.find(function (v) { return v.available; }) || variants[0];
    }

    // Initialize UI on load
    var initial = getCurrentVariant();
    if (initial) {
      updateVariantUI(initial);
    }

    // Listener for radio inputs / standard option selects
    scope.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-select]')) {
        var selectedOpts = [];
        var checkedInputs = scope.querySelectorAll('[data-option-select]:checked');
        checkedInputs.forEach(function (inp) {
          var idx = parseInt(inp.getAttribute('data-option-index'), 10);
          if (!isNaN(idx)) {
            selectedOpts[idx] = inp.value;
          }
        });

        // If color swatches exist, incorporate selected color
        var activeColor = scope.querySelector('[data-color-picker] [data-color-swatch].is-active');
        if (activeColor) {
          var colorVal = activeColor.getAttribute('data-color-value');
          // Find option index for color
          var colorPicker = activeColor.closest('[data-color-picker]');
          var colorIdx = colorPicker ? parseInt(colorPicker.getAttribute('data-option-index'), 10) : 0;
          if (!isNaN(colorIdx) && colorVal) {
            selectedOpts[colorIdx] = colorVal;
          }
        }

        var matched = variants.find(function (v) {
          return v.options.every(function (optVal, optIdx) {
            return selectedOpts[optIdx] == null || selectedOpts[optIdx] === optVal;
          });
        });

        if (matched) {
          updateVariantUI(matched);
        }
      }
    });

    // Listener for color swatches in .product__colors
    scope.addEventListener('click', function (e) {
      var swatch = e.target.closest('[data-color-swatch]');
      if (!swatch) return;

      var variantId = swatch.getAttribute('data-variant-id');
      var colorVal = swatch.getAttribute('data-color-value');
      var matchedVariant = null;

      if (variantId) {
        document.querySelectorAll('input[name="id"]').forEach(function(inp) { inp.value = variantId; });
        matchedVariant = variants.find(function (v) { return String(v.id) === String(variantId); });
      }

      if (!matchedVariant && colorVal) {
        // Look up currently selected options for other attributes (like size)
        var selectedOpts = [];
        var checkedInputs = scope.querySelectorAll('[data-option-select]:checked');
        checkedInputs.forEach(function (inp) {
          var idx = parseInt(inp.getAttribute('data-option-index'), 10);
          if (!isNaN(idx)) selectedOpts[idx] = inp.value;
        });

        matchedVariant = variants.find(function (v) {
          var hasColor = v.options.indexOf(colorVal) > -1;
          if (!hasColor) return false;
          return v.options.every(function (optVal, optIdx) {
            return selectedOpts[optIdx] == null || selectedOpts[optIdx] === optVal;
          });
        });

        if (!matchedVariant) {
          matchedVariant = variants.find(function (v) { return v.options.indexOf(colorVal) > -1; });
        }
      }

      if (matchedVariant) {
        updateVariantUI(matchedVariant);
      }
    });

    // Handle browser back/forward history navigation
    window.addEventListener('popstate', function () {
      var popped = getCurrentVariant();
      if (popped) {
        updateVariantUI(popped);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVariantSync();
    });
  } else {
    initVariantSync();
  }
})();
